'use client';
import dynamic from 'next/dynamic';
const Chat = dynamic(() => import('@/views/text/chatPage'), { ssr: false });

export default Chat;
